import { render, staticRenderFns } from "./UniIcons.vue?vue&type=template&id=4553cd4a&scoped=true"
import script from "./UniIcons.vue?vue&type=script&lang=js"
export * from "./UniIcons.vue?vue&type=script&lang=js"
import style0 from "./UniIcons.vue?vue&type=style&index=0&id=4553cd4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4553cd4a",
  null
  
)

export default component.exports